
import HttpClientApiKeyListaAcuerdos from '../../services/HttpClientApiKeyListaAcuerdos';
import HttpClientFileApiKey from '../../services/HttpClientFileApiKey';

import { AxiosError } from 'axios';

import { MateriaResponse } from '../../interfaces/comun/MateriaInterface';
import { AutoridadResponse } from '../../interfaces/comun/AutoridadInterface';
import { ListaAcuerdosResponse } from '../../interfaces/comun/ListaAcuerdosInterface';

export const ObtenerMaterias = () => {

    return new Promise<MateriaResponse>( (resolve, eject) => {   

        HttpClientApiKeyListaAcuerdos.get('/api/v5/materias?en_sentencias=true')
        .then( ({ data } : { data : MateriaResponse } ) => {               
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve({
                success: false,
                message: error.message,
                total: 0,
                limit: 0,
                offset: 0,  
                data: [],
            });
        });        

    });

}

export const ObtenerAutoridades = ( materiaClave: string ) => {

    return new Promise<AutoridadResponse>( (resolve, eject) => {   

        HttpClientApiKeyListaAcuerdos.get( `/api/v5/autoridades?distrito_clave=${ process.env.REACT_APP_DISTRITO_CLAVE }&es_jurisdiccional=true&es_notaria=false&materia_clave=${ materiaClave }`)
        .then( ({ data } : { data : AutoridadResponse } ) => {               
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve({
                success: false,
                message: error.message,
                total: 0,
                limit: 0,
                offset: 0,  
                data: [],
            });
        });        

    });

}

export const ObtenerListaAcuerdos = ( autoridadClave: string, offset: number = 0 ) => {

    return new Promise<ListaAcuerdosResponse>( (resolve, eject) => {   

        HttpClientApiKeyListaAcuerdos.get( `/api/v5/listas_de_acuerdos?autoridad_clave=${ autoridadClave }&offset=${ offset }`)
        .then( ({ data } : { data : ListaAcuerdosResponse } ) => {               
            resolve( data );                
        })
        .catch( ( error: AxiosError ) => {
            resolve({
                success: false,
                message: error.message,
                total: 0,
                limit: 0,
                offset: 0,  
                data: [],
            });
        });        

    });

}

export const ObtenerDocumentoListaAcuerdo = ( id: number ) => {

    return new Promise<Blob | null>( (resolve, eject) => {     

        HttpClientFileApiKey.get(`/api/v5/listas_de_acuerdos/visualizar/${ id }`)
        .then( ({ data } : { data : Blob } ) => {  
            resolve( data );                
        })
        .catch( () => {
            resolve( null );
        });        

    });

}